// ChooseCustomerForm.tsx
import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  CircularProgress,
} from '@mui/material';
import { useFetch } from "../../../hooks/useFetch2";
import { api } from '../../../api/customerApi';
import { useAuthStore } from '../../../store/useAuthStore3';

interface Customer {
  customer_id: number;
  legal_name: string;
  name: string;
}

const ChooseCustomerForm: React.FC = () => {
  const { customerId, setCustomerId, userId, userName, refresh } = useAuthStore();
  const { data: customers, error, loading } = useFetch<Customer[]>(api.getEntities, [], {
    mode: import.meta.env.DEV ? 'test' : 'live',
  });
  const [selectedCustomerId, setSelectedCustomerId] = useState<number | ''>(customerId || '');

  useEffect(() => {
    if (customerId) {
      setSelectedCustomerId(customerId);
    }
  }, [customerId]);

  const handleCustomerChange = (event: any) => {
    setSelectedCustomerId(event.target.value as number);
  };

  const handleSave = async () => {
    const chosenCustomer = customers.find(c => c.customer_id === selectedCustomerId);
    if (chosenCustomer) {
      const res = await api.changeCustomer(chosenCustomer.customer_id);
      if (res) {
        setCustomerId(chosenCustomer.customer_id || -1);
        refresh();
        alert(`Customer is set to: ${chosenCustomer.name}`);
      } else {
        alert(`Customer IS NOT set`);
      }
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 3 }}>
        <CircularProgress />
        <Typography sx={{ ml: 2 }}>Loading customers...</Typography>
      </Box>
    );
  }

  if (error) {
    return <Typography color="error">{error.message}</Typography>;
  }

  return (
    <Box sx={{ mt: 3 }}>
      <FormControl fullWidth>
        <InputLabel id="customer-select-label">Choose Customer</InputLabel>
        <Select
          labelId="customer-select-label"
          id="customer-select"
          value={selectedCustomerId}
          label="Choose Customer"
          onChange={handleCustomerChange}
        >
          {customers.map((cust) => (
            <MenuItem key={cust.customer_id} value={cust.customer_id}>
              {cust.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Button
        variant="contained"
        color="primary"
        onClick={handleSave}
        sx={{ mt: 2 }}
        disabled={!selectedCustomerId}
      >
        Set Customer
      </Button>
      {customerId && (
        <Typography variant="body1" sx={{ mt: 2 }}>
          Current Customer: <strong>{customers.find(c => c.customer_id === customerId)?.name}</strong>
        </Typography>
      )}
    </Box>
  );
};

export default ChooseCustomerForm;
